import React from 'react';

const VoucherRegisterPrint = ({ data }: { data: any }) => {
  return (
    <div className="font-sans text-[12px] text-black bg-white p-8 max-w-4xl mx-auto">
      <div className="text-center font-bold text-xl uppercase tracking-wider border-b-2 border-black pb-4 mb-4">
        {data.company.name}
      </div>
      <div className="text-center font-bold text-lg mb-2">{data.reportMeta.voucherType} Register</div>
      <div className="text-center mb-6 text-sm">Period: {data.reportMeta.period}</div>

      <table className="w-full border-collapse border border-gray-400 mb-8">
        <thead>
          <tr className="bg-gray-100">
            <th className="border border-gray-400 p-2 text-left">Date</th>
            <th className="border border-gray-400 p-2 text-left w-1/3">Particulars</th>
            <th className="border border-gray-400 p-2 text-left">Vch Type</th>
            <th className="border border-gray-400 p-2 text-left">Vch No.</th>
            <th className="border border-gray-400 p-2 text-right">Debit</th>
            <th className="border border-gray-400 p-2 text-right">Credit</th>
          </tr>
        </thead>
        <tbody>
          {data.vouchers.map((v: any, idx: number) => (
            <tr key={idx}>
              <td className="border border-gray-400 p-2 text-left">{v.date}</td>
              <td className="border border-gray-400 p-2 text-left">{v.particulars}</td>
              <td className="border border-gray-400 p-2 text-left">{v.vchType}</td>
              <td className="border border-gray-400 p-2 text-left">{v.vchNo}</td>
              <td className="border border-gray-400 p-2 text-right">{v.debit}</td>
              <td className="border border-gray-400 p-2 text-right">{v.credit}</td>
            </tr>
          ))}
          {data.vouchers.length === 0 && (
            <tr>
              <td colSpan={6} className="border border-gray-400 p-4 text-center italic text-gray-500">
                No vouchers found in this period.
              </td>
            </tr>
          )}
          <tr className="bg-gray-100 font-bold border-t-2 border-black">
            <td colSpan={4} className="border border-gray-400 p-2 text-right">Total</td>
            <td className="border border-gray-400 p-2 text-right">{data.totals.totalDebit}</td>
            <td className="border border-gray-400 p-2 text-right">{data.totals.totalCredit}</td>
          </tr>
        </tbody>
      </table>
      
      <div className="text-center text-[10px] text-gray-500 mt-8 space-y-1 border-t border-gray-300 pt-4">
        <p>This is a computer-generated report.</p>
        <p>Subject to Mumbai Jurisdiction.</p>
      </div>
    </div>
  );
};

export default VoucherRegisterPrint;
